import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { buildClassName } from 'utils/build-class-name';
import styles from './style.module.scss';

import type { PreConstructionProject } from '@zoocasa/pre-construction';
import PreConCard from '../precon-card';

// eslint-disable-next-line react-hooks/rules-of-hooks -- SwiperCore is a global instance
SwiperCore.use([Navigation, Pagination]);

export type PreConstructionProjectCarouselProps = {
  project: PreConstructionProject[];
};

export function PreConstructionProjectCarousel({ project }: PreConstructionProjectCarouselProps) {
  return (
    <div className={styles.component}>
      <Swiper
        className={buildClassName(styles.slider, 'vip-carousel')}
        loop
        navigation
        pagination={{ clickable: true }}
        slidesPerView='auto'
        spaceBetween={0}
      >
        {
          project.map((listing, index) => (
            <SwiperSlide virtualIndex={index} key={index} className={styles['vip-slide']}>
              <PreConCard listing={listing} />
            </SwiperSlide>
          ))
        }
      </Swiper>
    </div>
  );
}
